import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { deleteAssigmentApprovalUnit } from '@api/assignApprovalUnit';

import { ESnackbarTypes } from '@enums/common';

import {
	ASSIGN_APPROVAL_UNITS,
	ATTACHED_TYPES_SUBTYPES,
	DELETE_ASSIGNMENT_APPROVAL_UNIT,
	FILTER_ASSIGN_APPROVAL_UNITS,
} from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateDeleteAssignApprovalUnit = (onSettledCallbacks: Array<() => void>) => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const { mutate: handleDeleteAssignApprovalUnit } = useMutation<{ unitId: string }>({
		mutationKey: [DELETE_ASSIGNMENT_APPROVAL_UNIT],
		mutationFn: deleteAssigmentApprovalUnit,
		onSuccess: () => {
			onSettledCallbacks.forEach((callback) => callback());

			dispatch(
				setSnackbar({
					message: responseMessages.removeAssignmentApprovalUnit,
					type: ESnackbarTypes.success,
				}),
			);

			return [
				queryClient.invalidateQueries([ASSIGN_APPROVAL_UNITS]),
				queryClient.invalidateQueries([ATTACHED_TYPES_SUBTYPES]),
				queryClient.invalidateQueries([FILTER_ASSIGN_APPROVAL_UNITS]),
			];
		},
	});

	return { handleDeleteAssignApprovalUnit };
};
